<main class="o-layout__wrapper--full">
  <ls-iframe [page]="'iphone.html'"></ls-iframe>
</main>
